import { Spin } from "antd";
import type { SpinProps } from "antd";

export type UISpinProps = SpinProps;

export const UISpin = (props: UISpinProps) => <Spin {...props} />;
